'use client'

//@ts-ignore
import moengage from '@moengage/web-sdk'
import { captureMessage } from '@sentry/nextjs'
import { useFlag } from '@unleash/nextjs'
import { useEffect } from 'react'

const MoengageInit = () => {
  const enableMoengage = useFlag('enableMoengage')

  const initMoengage = (app_id: string | undefined, debugLogs: number) => {
    try {
      moengage.initialize({ app_id, debug_logs: debugLogs, swPath: '/serviceworker.js' })
    } catch (error: any) {
      if (error?.name === 'NotFoundError') {
        // eslint-disable-next-line no-console
        console.error('IndexedDB object store not found:', error)
        captureMessage(`IndexedDB object store not found: ${error}`, 'info')
      } else {
        throw error
      }
    }
  }

  useEffect(() => {
    if (!enableMoengage) {
      return
    }

    const app_id =
      process.env.NEXT_PUBLIC_APP_ENV === 'development'
        ? process.env.NEXT_PUBLIC_MOENGAGE_TEST_APP_ID
        : process.env.NEXT_PUBLIC_MOENGAGE_LIVE_APP_ID

    const debugLogs = 0

    initMoengage(app_id, debugLogs)
  }, [enableMoengage])

  return null
}

export default MoengageInit
